import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';
import { useAtomValue, useSetAtom } from 'jotai';
import { useHistory } from 'react-router-dom';

import { buildClaimPath } from '@/modules/claims/cleanClaims/helpers';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

import {
  batchReadyPatientsAtom,
  batchSessionAtom,
} from '../../../../modules/claims/cleanClaims/batchSession';

export const ClaimsBatchButton = () => {
  const batchReadyPatients = useAtomValue(batchReadyPatientsAtom);
  const setBatchSession = useSetAtom(batchSessionAtom);
  const history = useHistory();
  const { trackEvent } = useTrackEvent();

  if (batchReadyPatients.length === 0) return null;

  const handleStartBatchReview = () => {
    trackEvent(mixpanelEvents.batchReviewStarted, {
      patientCount: batchReadyPatients.length,
    });
    setBatchSession({
      patients: batchReadyPatients,
      startedAt: Date.now(),
      results: {},
    });
    history.push(
      buildClaimPath(
        batchReadyPatients[0].unifiedId,
        batchReadyPatients[0].estimatedVisitId,
        batchReadyPatients[0].imagingPatientId,
      ),
    );
  };

  return (
    <Button onClick={handleStartBatchReview}>
      <Trans>Review for PMS ({batchReadyPatients.length} attachments)</Trans>
    </Button>
  );
};
